import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { PayTypeIdSelect } from "../selects/PayTypeIdSelect";
import { PayrollPeriodIdSelectFilter } from "../selects/PayrollPeriodIdSelectFilter";
import { DateTimeInput } from "../inputs/DateTimeInput";
import { PayrollReasonCodePickerSelect } from "../../../../../common/selectComponents/PayrollReasonCodePicker";

export function EditAdjustmentForm({
  isOpen,
  onClose,
  employeePersonalInformationId,
  employeePersonalInformationFullName,
  payrollPeriodId,
  payTypeId,
  payrollReasonCodeId,
  amount,
  noOfHours,
  adjustmentDate,
  reference,
  referenceId,
  setEployeePersonalInformationId,
  setPayrollPeriodId,
  setPayTypeId,
  setPayrollReasonCodeId,
  setAmount,
  setAdjustmentDate,
  setReferenceId,
  setShowEmployeeForm,
  setNoOfHours,
  setReferenceIdForm,
  adjustmentType,
  handleUpdate,
}) {
  const [errorState, setErrorState] = useState(false);

  const requiresReasonCode =
    adjustmentType !== "OtherLateAdjustmentStaging";

  const submit = (e) => {
    console.log({ 
      triggered: "update 1 : ", 
      adjustmentType: (requiresReasonCode && !payrollReasonCodeId), 
      employeePersonalInformationId: !employeePersonalInformationId,
      payTypeId: !payTypeId,
      payrollReasonCodeId: !payrollReasonCodeId,
      amount: !amount,
    })

    if (
      !employeePersonalInformationId ||
      !payrollPeriodId ||
      !payTypeId ||
      (requiresReasonCode && !payrollReasonCodeId) ||
      !amount
    ) {
      if (adjustmentType === "OtherAdjustmentStaging") {
        if (!adjustmentDate || !referenceId || !noOfHours) {
          setErrorState(true);
          console.log({ triggered: "update 2" })

          return;
        }
      }
      console.log({ triggered: "update3 " })

      setErrorState(true);
      return;
    }
    console.log({ triggered: "update 4" })
    handleUpdate(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setEployeePersonalInformationId("");
    setPayrollPeriodId("");
    setPayTypeId("");
    setPayrollReasonCodeId(null);
    setAmount("");
    setAdjustmentDate("");
    setReferenceId("");
    setErrorState(false);
  };

  const handlePayrollReasonCodeChange = (payrollReasonCode) => {
    setPayrollReasonCodeId(payrollReasonCode?.id);
  };

  var formType = "";

  if (adjustmentType === "OtherAdditionStaging") {
    formType = "Update Other Addition Payroll";
  } else if (adjustmentType === "OtherDeductionStaging") {
    formType = "Update Other Deduction Payroll";
  } else if (adjustmentType === "OtherAdjustmentStaging") {
    formType = "Update Other Adjustment Payroll";
  } else if (adjustmentType === "OtherLateAdjustmentStaging") {
    formType = "Update Other Late Adjustment Payroll";
  }

  var refValue = "";
  if (
    referenceId !== undefined &&
    referenceId !== null &&
    referenceId !== "" &&
    referenceId !== 0
  ) {
    const value = referenceId;
    const formattedNumber = value.toString().padStart(6, "0");
    refValue =
      reference?.requestTypeId === 1
        ? `${formattedNumber}`
        : `${formattedNumber}`;
  }

  const [currentPayTypeId, setCurrentPayTypeId] = useState("");
  useEffect(() => {
    if (isOpen && currentPayTypeId !== payTypeId) {
      setCurrentPayTypeId(payTypeId);

      if (currentPayTypeId) {
        setPayrollPeriodId("");
      }
    }
  }, [currentPayTypeId, payTypeId, setPayrollPeriodId, isOpen]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{formType}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <div
                    className="info-item-holder employee-select row"
                    style={{ flexDirection: "row", justifyContent: "normal" }}
                  >
                    <input
                      readOnly
                      className="employeeInput-select"
                      placeholder="Employee"
                      style={{ cursor: "not-allowed" }}
                      value={
                        employeePersonalInformationId
                          ? employeePersonalInformationFullName
                          : employeePersonalInformationId
                      }
                    />
                  </div>
                </div>
                <span
                  style={{
                    visibility:
                      !employeePersonalInformationId && errorState
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeIdSelect
                    payTypeId={payTypeId}
                    setPayTypeId={setPayTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility: !payTypeId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Payroll Period</div>
                <div className="info-item-input">
                  <PayrollPeriodIdSelectFilter
                    payrollPeriodId={payrollPeriodId}
                    setPayrollPeriodId={setPayrollPeriodId}
                    payTypeId={payTypeId}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      (!payrollPeriodId && errorState) || !payTypeId
                        ? "visible"
                        : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  {!payTypeId
                    ? "Please select Pay Type first"
                    : "Please fill up this field"}
                </span>
              </div>
              {requiresReasonCode && (
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Payroll Reason</div>
                  <div className="info-item-input">
                    <PayrollReasonCodePickerSelect
                      value={{ id: payrollReasonCodeId }}
                      onChange={handlePayrollReasonCodeChange}
                      placeholder="Choose reason"
                      allowAll={false}
                    />
                  </div>
                  <span
                    style={{
                      visibility: !payrollReasonCodeId && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              )}
              <div className="popUp-item info-item column">
                <div className="info-item-label">Amount</div>
                <div className="info-item-input">
                  <input
                    type="number"
                    placeholder="Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility: !amount && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              {adjustmentType === "OtherAdjustmentStaging" ||
                adjustmentType === "OtherLateAdjustmentStaging" ? (
                <div>
                  <div
                    className="popUp-item info-item column"
                    style={{ display: "none" }}
                  >
                    <div className="info-item-label">Number of Hours</div>
                    <div className="info-item-input">
                      <input
                        type="number"
                        placeholder="Number of Hours"
                        value={noOfHours}
                        onChange={(e) => setNoOfHours(e.target.value)}
                      />
                    </div>
                    <span
                      style={{
                        visibility:
                          !noOfHours && errorState ? "visible" : "hidden",
                        color: "#ff6565",
                        fontSize: "12px",
                      }}
                    >
                      Please fill up this field
                    </span>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Adjustment Date</div>
                    <div className="info-item-input">
                      <DateTimeInput
                        date={adjustmentDate}
                        setDate={setAdjustmentDate}
                      />
                    </div>
                    <span
                      style={{
                        visibility:
                          !adjustmentDate && errorState ? "visible" : "hidden",
                        color: "#ff6565",
                        fontSize: "12px",
                      }}
                    >
                      Please fill up this field
                    </span>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Reference Id</div>
                    <div className="info-item-input">
                      <div
                        className="info-item-holder employee-select row"
                        style={{
                          flexDirection: "row",
                          justifyContent: "normal",
                        }}
                      >
                        <input
                          readOnly
                          className="employeeInput-select"
                          placeholder="Reference Id"
                          value={refValue}
                        />
                        <button
                          className="select row"
                          onClick={() => setReferenceIdForm(true)}
                        >
                          <SearchIcon />
                        </button>
                      </div>
                      <span
                        style={{
                          visibility:
                            !referenceId && errorState ? "visible" : "hidden",
                          color: "#ff6565",
                          fontSize: "12px",
                        }}
                      >
                        Please fill up this field
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
              >
                UPDATE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}